module.exports = __webpack_public_path__ + "img/Frame4302.193ba2e3.jpg";